/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PaginationComponent from "react-reactstrap-pagination";
import ProductTable from "./ProductTable";
import SettingTable from "./SettingTable";
import { toast } from 'react-toastify';
import { API_URL, downloadFile } from"network"

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardTitle, CardText } from 'reactstrap';
import classnames from 'classnames';


// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";


import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'


function Index(props) {
  const [deleteTableData, setDeleteTableData] = useState([]);
  const [newTableData, setNewTableData] = useState([]);
  const [updateTableData, setUpdateTableData] = useState([]);
  const [settingTableData, setSettingTableData] = useState([]);
  const [loaded, setLoaded] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [matching, setMatching] = useState(false);
  const [activeTab, setActiveTabe] = useState('1');  
  const [downloadProvider, setDownloadProvider] = useState(null)
  const [supplierInfo, setSupplierInfo] = useState(false)
  const [uploadedSampleCsv, setUploadedSampleCsv] = useState(false)
  
  const toggletab=(tab)=> {
    if (activeTab !== tab) {
      setActiveTabe(tab)
    }
  }
  const main = useRef();
  const fileRef = useRef(null);
  const [modal, setModal] = useState(false);
  const [provider, setProvider] = useState("");
  const [settingProvider, setSettingProvider] = useState("");  

  useEffect(() => {
    if(activeTab == "2"){
      setLoaded(false)
      axios.get('/uploadproducts/index', {
        params: {
        }
      }).then(res => {
        console.log('res.data',res.data)
        if(res.data.status == "success"){
          setLoaded(true)
          setDeleteTableData(res.data.data['deleteProducts'])
          setNewTableData(res.data.data['newProducts'])
          setUpdateTableData(res.data.data['updateProducts'])
        }
      })    
    }
  },[activeTab]);

  const updateSettingProvider = (value)=>{
    setSettingProvider(value);
    if(value){
      setLoaded(false)
      axios.get(`/products/getsizes/${value}`, {
        params: {
        }
      }).then(res => {
        console.log('res.data',res.data)
        if(res.data.status == "success"){
          setLoaded(true)
          var tabledata = res.data.data['sizedata']
          tabledata.sort((a, b) => {
            if (a.position === b.position){
              return a.sizename < b.sizename ? -1 : 1
            } else {
              return a.position < b.position ? -1 : 1
            }
          })
          setSettingTableData(tabledata)
        }
      })    
    }
  }

  
  const setposition = (index, value)=>{
    var tmp = [...settingTableData];
    tmp[index]['position']  = value
    setSettingTableData(tmp)
  }

  const updateposition = (index, value)=>{
    var tmp = [...settingTableData];
    tmp[index]['position']  = value

    var bodyFormData = new FormData();
    bodyFormData.append('sizename', tmp[index]['sizename']);
    bodyFormData.append('position', value);

    axios.post(`/products/setsizeorder/${settingProvider}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){ 
        // setSettingTableData(res.data.data['sizedata'])
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
    tmp.sort((a, b) => {
      if (a.position === b.position){
        return a.sizename < b.sizename ? -1 : 1
      } else {
        return a.position < b.position ? -1 : 1
      }
    })
    setSettingTableData(tmp)
    // tmp.sort((a, b) => (a.position > b.position) ? 1 : -1)
    // setSettingTableData(tmp)
  }
  
  const uploadProduct=()=>{    // panther
    if(!provider){
      alert("Select provider!")
      return false;
    }
    setUploading(true)
    var bodyFormData = new FormData();
    bodyFormData.append('supplier', provider);
    if(fileRef.current.files[0])
      bodyFormData.append('file', fileRef.current.files[0]);
    axios.post(`/pages/upload`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("The products have been uploaded");
        setUploading(false)
        setUploaded(true)
        setUploadedSampleCsv(result.data)
      }
      else{
        toast.error(result.data);
        setUploading(false)
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
      setUploading(false)
    })
  }
  const submitProduct=()=>{
    setSubmitting(true)
    var bodyFormData = new FormData();
    bodyFormData.append('supplier', provider);
    if(uploadedSampleCsv)
      bodyFormData.append('standard_csv', JSON.stringify(uploadedSampleCsv));
    axios.post(`/uploadproducts/add`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("The products have been accepted");
        setSubmitting(false)
        setDeleteTableData(res.data.data['deleteProducts'])
        setNewTableData(res.data.data['newProducts'])
        setUpdateTableData(res.data.data['updateProducts'])
      }
      else{
        toast.error(result.data);
        setSubmitting(false)
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
      setSubmitting(false)
    })
  }
  const syncWorkFlowMax=()=>{
    if(!provider){
      alert("Select provider!")
      return false;
    }
    setMatching(true)
    var supplier_arry = {
      'Shiny':'WS',
      'Ramo':'RM',
      'AS Colour':'AS',
      'JBs Wear':'JB',
      'Fashion Biz':'BIZ',
      'Flexfit':'MAC',
      'Mac':'Macleod Scotland',
      'Grace Collection':'GC',
      'Portwest':'PW',
      'Aussie Pacific':'AP',
      'Bisley':'BIS',
      'Jet Pilot':'JP',
      'Headwear':'HW',
      'Bad Workwear':'BAD',
      'DNC':'DNC',
      'Identitee':'ID',
      'HY':'HY',
      'KG':'KG',
      'Gildan Brands':'GD',
      'Puma Safety':'BIS', // -duc-
      'Buck Sports':'BS', // mykhailo
      'NCC Apparel Pty Ltd':'NCCA',
    };

    var bodyFormData = new FormData();
    bodyFormData.append('supplier', supplier_arry[provider]);
    axios.post(`/uploadProducts/deletexero`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("The products deleting from workflowmax started");
        setMatching(false)
      }
      else{
        toast.error(result.data);
        setMatching(false)
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
      setMatching(false)
    })
  }

  const downloadTemplates=()=>{
    setMatching(true)
    var bodyFormData = new FormData();
    axios.post(`/xero/getxerotemplate`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("The data downloaded from WorkflowMax");
        setMatching(false)
      }
      else{
        toast.error(result.data);
        setMatching(false)
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
      setMatching(false)
    })
  }
  
  const downloadProduct=()=>{
    // setUploading(true)
    window.open(
      `${API_URL}files/output.csv`,
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  
  const downloadProviderProduct=()=>{
    // setUploading(true)
    if(downloadProvider){
      downloadFile(`/products/downloadcsv/${downloadProvider}`, downloadProvider+".csv")
      // window.open(
      //   `${API_URL}products/downloadcsv/${downloadProvider}`,
      //   '_blank' // <- This is what makes it open in a new window.
      // );
    }
  }

  const downloadProviderSquare=()=>{
    // setUploading(true)
    if(downloadProvider){
      downloadFile(`/products/downloadsquare/${downloadProvider}`, downloadProvider+".csv")
      // window.open(
      //   `${API_URL}products/downloadsquare/${downloadProvider}`,
      //   '_blank' // <- This is what makes it open in a new window.
      // );
    }
  }

  const getSupplier = (name)=>{
    if(!name || name == ''){
      setSupplierInfo(false)
      return;
    }
    setSubmitting(true)
    axios.get(`/quotes/getSupplier/?supplierName=${name}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success"){
        setSubmitting(false)
        setSupplierInfo(res.data.data)
      }
    }) 
  }
  
  console.log("supplierInfo", supplierInfo)
  let standard_csv = supplierInfo?.standard_csv
  if(standard_csv && standard_csv != ''){
    standard_csv = JSON.parse(standard_csv)
  }
  console.log("standard_csv", standard_csv)
  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row className="mt-3 orders-tabs">
            <Col  md="12">
              <div>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => { toggletab('1'); }}
                    >
                      WFM
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => { toggletab('2'); }}
                    >
                      Upload
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => { toggletab('3'); }}
                    >
                      Setting Size
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '4' })}
                      onClick={() => { toggletab('4'); }}
                    >
                      Download
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="">                    
                    <div style={{marginTop:'0', borderRadius:'5px', background:'white'}}>
                      <div className="p-3">
                        <Row className="mt-3">
                          <Col>
                            <FormGroup className="mr-2">
                              <Button
                                onClick={downloadTemplates}
                                className="btn-icon btn-3" color="primary" type="button">
                                <span className="btn-inner--text">DOWNLOAD TEMPLATES/TASKS</span>
                              </Button>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane tabId="2" className=""> 
                    <Row style={{marginTop:'0'}}>
                      <Col  md="12">
                          <h5 className="p-3">Upload Products</h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col  md="12">
                        <div style={{marginTop:'0', borderRadius:'5px', background:'white'}}>
                          <div className="p-3">
                            <Row>
                              <Col  md="4">
                                <FormGroup>
                                  <Label>Choose File</Label>
                                  <div>
                                  <input type="file" ref={fileRef}/>
                                  </div>
                                </FormGroup>
                              </Col>
                              <Col  md="4">
                                <FormGroup>
                                  <Label for="exampleSelectMulti">Provider</Label>
                                  <Input type="select" name="provider" onChange={(e)=>{setProvider(e.target.value); getSupplier(e.target.value)}}>
                                    <option value = "">Select Provider</option>
                                    <option value = "Shiny">Shiny</option>
                                    <option value = "Ramo">Ramo</option>
                                    <option value = "AS Colour">AS Colour</option>
                                    <option value = "JBs Wear">JBs Wear</option>
                                    <option value = "Fashion Biz">Fashion Biz</option>
                                    <option value = "Syzmik">Syzmik</option>
                                    <option value = "Flexfit">Flexfit</option>   
                                    <option value = "Grace Collection">Grace Collection</option>   
                                    <option value = "Portwest">Portwest</option>    
                                    <option value = "Aussie Pacific">Aussie Pacific</option>  
                                    <option value = "Bisley">Bisley</option>   
                                    <option value = "Jet Pilot">Jet Pilot</option>   
                                    <option value = "Headwear">Headwear</option>   
                                    <option value = "BAD">Bad Workwear</option>  
                                    <option value = "DNC">DNC</option>  
                                    <option value = "ID">Identitee</option>  
                                    <option value = "HY">Hard Yakka</option>   
                                    <option value = "KG">King Gee</option>  
                                    <option value = "GD">Gildan Brands</option>
                                    {/* -mykhailo- */}
                                    <option value = "PS">Puma Safety</option>
                                    <option value = "BS">Buck Sports</option>
                                    <option value = "NCCA">NCC Apparel Pty Ltd</option>
                                    

                                  </Input>
                                </FormGroup>
                              </Col>
                              <Col  md="6">
                                <FormGroup>
                                  <Button
                                    onClick={uploadProduct}
                                    className="btn-icon btn-3" color="primary" type="button">
                                    <span className="btn-inner--text">Upload</span>
                                  </Button>
                                </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                          
                          {
                          standard_csv && standard_csv?.length &&
                          <div className="pt-2 pb-2 pl-3 pr-3" style={{overflowX:'auto'}}>
                            <h6><b>Standard Csv</b></h6>
                            <Table  striped style={{width:'unset', minWidth:'100%'}}>
                              <tbody>
                                {
                                  standard_csv.map((row, index)=>{                          
                                    return (
                                      <tr key={index}>
                                      {
                                        row.map((cell, cell_index)=>{                          
                                          return (
                                              <td key={`${index}`-`${cell_index}`} scope="row">{cell}</td>
                                          )
                                        })
                                      }
                                      </tr>
                                    )
                                  })
                                }
                              </tbody>
                            </Table>
                          </div>
                          }
                          {
                          uploadedSampleCsv && uploadedSampleCsv?.length &&
                          <div className="pt-2 pb-2 pl-3 pr-3" style={{overflowX:'auto'}}>
                            <h6><b>New Csv</b></h6>
                            <Table  striped style={{width:'unset', minWidth:'100%'}}>
                              <tbody>
                                {
                                  uploadedSampleCsv.map((row, index)=>{                          
                                    return (
                                      <tr key={index}>
                                      {
                                        row.map((cell, cell_index)=>{                          
                                          return (
                                              <td key={`${index}`-`${cell_index}`} scope="row">{cell}</td>
                                          )
                                        })
                                      }
                                      </tr>
                                    )
                                  })
                                }
                              </tbody>
                            </Table>
                          </div>
                          }
                        </div>
                      </Col>
                    </Row>
                    <Row style={{marginTop:'50px'}}>
                      <Col  md="6">
                        <h5 className="p-3">Review</h5>
                      </Col>
                      <Col  md="6">
                        {/* {uploaded && */}
                        <div className="review-btn">
                          <FormGroup className="mr-2">
                            <Button
                              onClick={submitProduct}
                              className="btn-icon btn-3" color="primary" type="button">
                              <span className="btn-inner--text">ACCEPT and SUBMIT</span>
                            </Button>
                          </FormGroup>
                          {/* <FormGroup className="mr-2">
                            <Button
                              onClick={downloadProduct}
                              className="btn-icon btn-3" color="primary" type="button">
                              <span className="btn-inner--text">DOWNLOAD CSV</span>
                            </Button>
                          </FormGroup> */}
                          <FormGroup>
                            <Button
                              onClick={syncWorkFlowMax}
                              className="btn-icon btn-3" color="primary" type="button">
                              <span className="btn-inner--text">Delete WorkFlowMax</span>
                            </Button>
                          </FormGroup>
                        </div>
                        {/* } */}
                      </Col>
                    </Row>
                    <Row>
                      <Col  md="12">
                        <div style={{marginTop:'0', borderRadius:'5px', background:'white'}}>
                          <h5 className="p-3">Products to be deleted</h5>
                          <div style={{overflow:'auto'}}>
                            <ProductTable tableData = {deleteTableData}/>
                          </div>
                        </div>
                      </Col>
                      <Col  md="12">
                        <div style={{marginTop:'65px', borderRadius:'5px', background:'white'}}>
                          <h5 className="p-3">Products to be updated</h5>
                          <div style={{overflow:'auto'}}>                
                            <ProductTable tableData = {updateTableData}/>
                          </div>
                        </div>
                      </Col>
                      <Col  md="12">
                        <div style={{marginTop:'65px', borderRadius:'5px', background:'white'}}>
                          <h5 className="p-3">Products to be added</h5>
                          <div style={{overflow:'auto'}}>             
                            <ProductTable tableData = {newTableData}/>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3" className="">                    
                    <div style={{marginTop:'0', borderRadius:'5px', background:'white'}}>
                      <div className="p-3">
                        <Row className="mt-3">                             
                          <Col  md="3">
                            <FormGroup>
                              <Label for="exampleSelectMulti">Provider</Label>
                              <Input type="select" name="settingProvider" onChange={(e)=>updateSettingProvider(e.target.value)}>
                                <option value = "">Select Provider</option>
                                <option value = "WS">Shiny</option>
                                <option value = "RM">Ramo</option>
                                <option value = "AS">AS Colour</option>
                                <option value = "JB">JBs Wear</option>
                                <option value = "BIZ">Fashion Biz</option>
                                <option value = "SYZ">Syzmik</option>         
                                <option value = "Mac">Flexfit</option>   
                                <option value = "GC">Grace Collection</option>   
                                <option value = "PW">Portwest</option>    
                                <option value = "AP">Aussie Pacific</option>  
                                <option value = "BIS">Bisley</option>   
                                <option value = "JP">Jet Pilot</option>   
                                <option value = "HW">Headwear</option>   
                                <option value = "BAD">Bad Workwear</option>  
                                <option value = "DNC">DNC</option>  
                                <option value = "ID">Identitee</option>  
                                <option value = "HY">Hard Yakka</option>   
                                <option value = "KG">King Gee</option>  
                                <option value = "GD">Gildan Brands</option>  
                                {/* -duc- */}
                                <option value = "PS">Puma Safety</option>
                                <option value = "BS">Buck Sports</option>
                                <option value = "NCCA">NCC Apparel Pty Ltd</option>
                              </Input>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col>
                            <SettingTable tableData = {settingTableData} setposition={setposition} updateposition={updateposition}/>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane tabId="4" className="">                    
                    <div style={{marginTop:'0', borderRadius:'5px', background:'white'}}>
                      <div className="p-3">
                        <Row className="mt-3">                             
                          <Col  md="3">
                            <FormGroup>
                              <Label for="exampleSelectMulti">Provider</Label>
                              <Input type="select" name="settingProvider" onChange={(e)=>setDownloadProvider(e.target.value)}>
                                <option value = "">Select Provider</option>
                                <option value = "WS">Shiny</option>
                                <option value = "RM">Ramo</option>
                                <option value = "AS">AS Colour</option>
                                <option value = "JB">JBs Wear</option>
                                <option value = "BIZ">Fashion Biz</option>
                                <option value = "SYZ">Syzmik</option>         
                                <option value = "Mac">Flexfit</option>   
                                <option value = "GC">Grace Collection</option>   
                                <option value = "PW">Portwest</option>    
                                <option value = "AP">Aussie Pacific</option>  
                                <option value = "BIS">Bisley</option>   
                                <option value = "JP">Jet Pilot</option>   
                                <option value = "HW">Headwear</option>   
                                <option value = "BAD">Bad Workwear</option>   
                                <option value = "DNC">DNC</option>   
                                <option value = "ID">Identitee</option>  
                                <option value = "HY">Hard Yakka</option>   
                                <option value = "KG">King Gee</option>    
                                <option value = "GD">Gildan Brands</option>  
                                {/* -mykahilo- */}
                                <option value = "PS">Puma Safety</option>
                                <option value = "BS">Buck Sports</option>
                                <option value = "NCCA">NCC Apparel Pty Ltd</option>
                                
                              </Input>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col className="d-flex">
                            <FormGroup className="mr-2">
                              <Button
                                onClick={downloadProviderProduct}
                                className="btn-icon btn-3" color="primary" type="button">
                                <span className="btn-inner--text">DOWNLOAD CSV</span>
                              </Button>
                            </FormGroup>
                            <FormGroup className="mr-2">
                              <Button
                                onClick={downloadProviderSquare}
                                className="btn-icon btn-3" color="primary" type="button">
                                <span className="btn-inner--text">DOWNLOAD SQUARE</span>
                              </Button>
                            </FormGroup>
                          </Col>
                          <Col>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
          
          <LoadingOverlay
            active={!loaded || uploading || submitting || matching}
            styles={{
                overlay: (base) => ({
                ...base,
                fontSize:'18px',
                color: 'rgb(5, 37, 51)',
                background: 'rgb(60 60 60 / 48%)',
                position:'fixed',
                zIndex:1000000000
                })
            }}
            spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
            // spinner
            // text='Loading ...'
            >
          </LoadingOverlay>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
